import baseTemplate from './pdp-selector.html';


/**
 * generate a promo legend  element
 * @param {string} id // id string for attribute
 * @param {string|number} index // index to indicate which selector this is
 * @param {string} name // name string for attribute
 * @param {string} desc // descition string for attribute
 * @param {string} iconURL // icon url
 * @returns {string} // html string representation of a main slide
 */
 const promoLegend = ({ id, index, name, desc, iconURL }) => `
    <div class="promo-pill" data-index="${index}" data-id="${id}" data-toggle="popover-hover" data-target="tooltip1" data-placement="top" title="${desc}">
        <img class="promo-pill__icon" src="${iconURL}" />
        <span data-region="name">${name}</span>
        <span class="promo-pill__chervon fa fa-chevron-down" aria-hidden="true"></span>
        <div id="tooltip1" style="display: none;" data-region="description">${desc}</div>
    </div>
`;

/**
 * generate a selector <select> box element
 * @param {string} id // id string for attribute
 * @param {string|number} index // index to indicate which selector this is
 * @param {string} name // name string for attribute
 * @returns {string} // html string representation of a main slide
 */
const selectBox = ({ id, index, name }) => `
    <div class="pdp-info__selector" data-region="selector">
        <div class="select-box">
            <select class="select-box__select" name="${name}" id="${id}" data-control="selector" data-index="${index}">
            </select>
        </div>
    </div>
`;

/**
 * generate a selector <label> element
 * @param {string} id // id string to bind to <select> box (should match a corresponding selectBox)
 * @param {string} label // text to display
 * @returns {string} // html string representation of a main slide
 */
const selectLabel = ({ id, label }) => `
    <label class="pdp-info__label" for="${id}" data-region="selectorLabel">
        ${label}
    </label>
`;

/**
 * generate a selector <select> box element
 * @param {string} disabled // indicate if option is disabled
 * @param {string} name // text to display
 * * @param {string} value // value string for attribute
 * @returns {string} // html string representation of a main slide
 */
const selectOption = ({ disabled, name, value } = { disabled: false, name: '', value: '' }) => `
    <option
        value="${value}"
        ${disabled ? ' disabled' : ''}>
        ${name}
    </option>
`;

export {
    selectBox,
    selectLabel,
    selectOption,
    promoLegend
};

export default baseTemplate;
